<template>
<div class="outlineClass">
  <div class="firstPart1">
    <div class="part1" oncontextmenu = "return false" oncopy = "return false" onselectstart = "return false">
    </div>
    <div class="part2"></div>
    <div class="part3"></div>
    <div class="part4"></div>
  </div>

  <div class="part5" style="display: none" v-show="vShow">
    <span style="color:white">Copyright ©2019 创益星 版权所有 <a  style="color:white" href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备19070479号-1</a>  江苏中尚机器人科技有限公司</span>
  </div>

</div>
</template>

<script>
  export default {
        name: "Home",
    data(){
      return{
        vShow:false,
      }

    },
  mounted(){
    window.setInterval(this.vShow=true,3000);
  }
    }
</script>

<style scoped>
.outlineClass{
position: relative;
  z-index: 20;
}
  .part5{
    background-color: black;
    text-align: center;
  }
  .firstPart1{
    width: 100%;
    min-height: 62rem;
  }
  .part1{
    min-height: 58rem;
    background: url("../../assets/images/home/home_part1.png");
  }
  .part2{
    min-height: 60rem;
    background: url("../../assets/images/home/home_part2.png");
  }
.part3{
  min-height: 76rem;
  background: url("../../assets/images/home/home_part3.png");
}
.part4{
  min-height: 24rem;
  background: url("../../assets/images/home/Footer.png");
}
</style>



// WEBPACK FOOTER //
// src/components/home/chineseHome.vue